import instance from "./instance";


const crmCampaignAttribution = async (reqData) => {
    try {
        const { data } = await instance.post('/common/crmCampaignAttribution', reqData)
        if (data && data.resultCode === 'S') {
            console.log("resultCode",data);
        }
        else Promise.reject(data.resultMessage)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const submitCRMCampaignApi=async (qNumber,lobcode) => {
    let localData = JSON.parse(await localStorage.getItem("paramAttributes"));
    let {fbclid,utm_source,utm_medium,utm_campaign,utm_content,utm_term,utm_promocode,campid,gclid,ttclid,dclid} =localData;
    let reqData = {
        "fbclid": fbclid || "",
        "utm_source": utm_source || "",
        "utm_medium": utm_medium || "",
        "utm_campaign": utm_campaign || "",
        "utm_content": utm_content || "",
        "utm_term": utm_term || "",
        "utm_promocode": utm_promocode || "",
        "campid": campid || "",
        "gclid": gclid || "",
        "ttclid": ttclid || "",
        "dclid": dclid || "",
        "quotation_no": qNumber.toString() || "",
        "lobcode": lobcode || "",
    }
    console.log(reqData,'localData####',localData.utm_source);
    crmCampaignAttribution(reqData);
}
